import { AreaChart } from "@tremor/react";

const customTooltip = ({ payload, active, label }) => {
    if (!active || !payload) return null;
    return (
        <div className="w-56 rounded-tremor-default text-tremor-default bg-tremor-background p-2 shadow-tremor-dropdown border border-tremor-border">
            <p className="font-medium text-tremor-content-emphasis mb-1">{label}</p>
            <div className="flex flex-row">
                {payload.map((category, idx) => (
                    <div key={idx} className="flex flex-1 space-x-2.5 mt-1">
                        <div className={`w-1 flex flex-col bg-${category.color}-500 rounded`} />
                        <div className="space-y-1">
                            <p className="text-tremor-content">{category.dataKey}</p>
                            <p className="font-medium text-tremor-content-emphasis">{category.value}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

const valueFormatter = function (number) {
    return number.toString();
};

export default function BillingChart({ billingChart, pagesChart }) {
    // Merge the data from billingChart and pagesChart
    const combinedData = billingChart.map(item => {
        const pagesItem = pagesChart.find(p => p.day === item.day);
        return {
            ...item,
            Pages: pagesItem ? pagesItem.Pages : 0
        };
    });

    return (
        <AreaChart
            className="h-60 mt-4"
            data={combinedData}
            index="day"
            categories={["Requests", "Pages"]}
            colors={["indigo", "green"]}
            showAnimation={true}
            showLegend={true}
            allowDecimals={false}
            valueFormatter={valueFormatter}
            customTooltip={customTooltip}
            yAxisWidth={68}
        />
    );
}